var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronicCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 50,
    viewBox: "0 0 73 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Electronic Card",
    clipPath: "url(#clip0_438_7304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.7273 11.7898V7.95455C72.7273 3.56136 69.1659 0 64.7727 0H7.95455C3.56136 0 0 3.56136 0 7.95455V11.7898C0 11.9781 0.0748273 12.1588 0.208021 12.292C0.341214 12.4252 0.521863 12.5 0.710227 12.5H72.017C72.2054 12.5 72.3861 12.4252 72.5192 12.292C72.6524 12.1588 72.7273 11.9781 72.7273 11.7898ZM0 17.7557V42.0455C0 46.4386 3.56136 50 7.95455 50H64.7727C69.1659 50 72.7273 46.4386 72.7273 42.0455V17.7557C72.7273 17.5673 72.6524 17.3867 72.5192 17.2535C72.3861 17.1203 72.2054 17.0455 72.017 17.0455H0.710227C0.521863 17.0455 0.341214 17.1203 0.208021 17.2535C0.0748273 17.3867 0 17.5673 0 17.7557ZM18.1818 36.3636C18.1818 37.6188 17.1642 38.6364 15.9091 38.6364H13.6364C12.3812 38.6364 11.3636 37.6188 11.3636 36.3636V34.0909C11.3636 32.8358 12.3812 31.8182 13.6364 31.8182H15.9091C17.1642 31.8182 18.1818 32.8358 18.1818 34.0909V36.3636Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_7304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.7273,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicCard);
export default __webpack_public_path__ + "static/media/electronic-card.978d4a8d3f531bb922b30a30a704a765.svg";
export { ForwardRef as ReactComponent };